const mutations = {
  setMetadado(state, { owner, metadado }) {
    if (state.hasOwnProperty(owner)) {
      state[owner] = metadado;
    }
  },
};

const actions = {
  setMetadado({ commit }, {
    owner,
    resource,
    params = null,
    callback,
  }) {
    if (owner && resource) {
      resource(params)
        .then((res) => {
          const metadado = res.body;
          commit('setMetadado', { owner, metadado });
          if (callback) {
            callback();
          }
        });
    }
  },
  setClienteMetadado({ commit }, { resource, params, callback }) {
    actions.setMetadado({ commit }, {
      owner: 'cliente',
      resource,
      params,
      callback,
    });
  },
  setUsuarioMetadado({ commit }, { resource, params }) {
    actions.setMetadado({ commit }, {
      owner: 'usuario',
      resource,
      params,
    });
  },
  setProdutoMetadado({ commit }, { resource, params }) {
    actions.setMetadado({ commit }, {
      owner: 'produto',
      resource,
      params,
    });
  },
  setDivisaoMetadado({ commit }, { resource, params }) {
    actions.setMetadado({ commit }, {
      owner: 'divisao',
      resource,
      params,
    });
  },
  setCentroCustoMetadado({ commit }, { resource, params }) {
    actions.setMetadado({ commit }, {
      owner: 'ceco',
      resource,
      params,
    });
  },
  setAcaoMetadado({ commit }, { resource, params, callback }) {
    actions.setMetadado({ commit }, {
      owner: 'acao',
      resource,
      params,
      callback,
    });
  },
  setContratoMetadado({ commit }, { resource, params, callback }) {
    actions.setMetadado({ commit }, {
      owner: 'contrato',
      resource,
      params,
      callback,
    });
  },
  setFornecedorMetadado({ commit }, { resource, params, callback }) {
    actions.setMetadado({ commit }, {
      owner: 'fornecedor',
      resource,
      params,
      callback,
    });
  },
  setFilialMetadado({ commit }, { resource, params, callback }) {
    actions.setMetadado({ commit }, {
      owner: 'filial',
      resource,
      params,
      callback,
    });
  },
};

const getters = {
  getClienteMetadado(state) {
    return state.cliente;
  },
  getProdutoMetadado(state) {
    return state.produto;
  },
  getUsuarioMetadado(state) {
    return state.usuario;
  },
  getDivisaoMetadado(state) {
    return state.divisao;
  },
  getCentroCustoMetadado(state) {
    return state.ceco;
  },
  getAcaoMetadado(state) {
    return state.acao;
  },
  getContratoMetadado(state) {
    return state.contrato;
  },
  getFornecedorMetadado(state) {
    return state.fornecedor;
  },
  getFilialMetadado(state) {
    return state.filial;
  },
};

const state = {
  cliente: null,
  produto: null,
  usuario: null,
  divisao: null,
  ceco: null,
  acao: null,
  apuracao: null,
  contrato: null,
  fornecedor: null,
  filial: null,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
